import React, { useEffect, useState } from "react";
import nli from "./NotificationListItem.module.css";
import styled from '@emotion/styled';

const Wrapper = styled.div`
   position: relative;
    margin-bottom: 12px;
    top: 10px;
    height: 81px;
    background-color: var(--color-gray-200);
    /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.08); */
    border-radius: 4px;
    border: ${props => props.selected ? '1px solid var(--color-blue-500)' : '1px solid var(--color-gray-400)'};

    .liwelement{
    font-size: 14px;
    color: #6E7B87;
    position: absolute;
    left: 36px;
    top: 12px;
    right: 12px;
}

.liwelement_two{
    font-size: 14px;
    top: 14px;
    right: 12px;
    font-size: 12px;
    color: #6E7B87;
    position: absolute;
}

> img{
    margin-right: 12px;
    position: absolute;
    top: 12px;
    left: 12px;
}

> p {
    font-size: 14px;
    position: absolute;
    top: 38px;
    bottom: 12px;
    left: 36px;
    right: 12;
    color: #6E7B87;
    font-size: 12px;
}

.imagediv{
    position: absolute;
    left: 12.75px;
    top: 32px;
}
`;

function NotificationListItem(props) {

    const [message, setMessage] = useState('');
    const [icon, setIcon] = useState('');
    const [flagged, setFlagged] = useState('');
    const [selected, setSelected] = useState(false)

    useEffect(() =>{
        switch(props.type){
            case "order":
                 setMessage("New Order Received");
                 setIcon("/icons/ellipse_purple.svg");
                 break;
            case "contact":
                setMessage("Customer Message Received");
                setIcon("/icons/ellipse_green.svg");
                break;
        }

        if(props.flag){
            setFlagged("/icons/flagged.svg");
        }
        console.log(props.selected);
    })

    return (
        <Wrapper selected={props.key ? selected:false} onClick={()=>setSelected(true)}>
            <img src={icon}></img>
            <div>
                <span className={nli.liwelement}>{message}</span><span className={nli.liwelement_two}>{props.date.toLocaleDateString()}</span>
            </div>
            <p>
                {props.content}
            </p>
            <div className={nli.imagediv}>
                <img src={flagged}></img>
            </div>
        </Wrapper>
    )
}

export default NotificationListItem;